__webpack_require__.p = "https://webid.cdn.dhgamesdownload.com/assets/predictor.pagostore.com/";